import React, {useEffect, useState} from 'react';
import './Header.css';
import Logo from '../assets/logo.png';
import ReactSwitch from "react-switch";

function Header({ toggleDarkMode, darkMode }) {

    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const hero = document.getElementById("hero");
            if (hero) {
                const heroBottom = hero.getBoundingClientRect().bottom;
                setScrolled(heroBottom <= 50);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleNavClick = () => {
        setMenuOpen(false);
    };

    return (
        <>
            <div className="mantenimiento" role="alert">
                Sitio en mantenimiento. Algunas funciones pueden no estar disponibles.
            </div>
            <header className={`header ${scrolled ? "scrolled" : ""} ${darkMode ? "dark-mode" : ""}`}>
                <img src={Logo} alt="Desafío Extremo - Skydiving Uruguay" className="header__logo" />
                <button
                    className={`header__hamburger ${menuOpen ? "open" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Abrir menú de navegación"
                    aria-expanded={menuOpen}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <nav className={`header__nav ${menuOpen ? "header__nav--open" : ""}`}>
                    <a href="#hero" onClick={handleNavClick}>Inicio</a>
                    <a href="#about" onClick={handleNavClick}>Sobre Nosotros</a>
                    <a href="#services" onClick={handleNavClick}>Servicios</a>
                    <a href="#gallery" onClick={handleNavClick}>Galería</a>
                    <a href="#contact" onClick={handleNavClick}>Contacto</a>
                </nav>
                <div className="header__darkmode">
                    <label htmlFor="darkMode" className="darkModeLabel">Modo Oscuro</label>
                    <ReactSwitch
                        checked={darkMode}
                        onChange={toggleDarkMode}
                        offColor="#888"
                        onColor="#4caf50"
                        offHandleColor="#fff"
                        onHandleColor="#fff"
                        height={20}
                        width={40}
                        aria-label="Activar modo oscuro"
                    />
                </div>
            </header>
        </>
    );
}

export default Header;
